import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { Subscription } from 'rxjs';
import { BottomsheetShared } from './../../../general/shared/bottomsheet-shared';
import { ResponseDayExerciseLogs } from './../../../../core/model/api-response/plans-response-model';
import { ExerciseLogService } from './../../../../data/repository/plan-repository/exercise-log.service';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';

@Component({
  selector: 'app-exercise-main',
  templateUrl: './exercise-main.component.html',
  styleUrls: ['./exercise-main.component.scss'],
})
export class ExerciseMainComponent implements OnInit, OnDestroy {
  exercises: ResponseDayExerciseLogs[];
  date: number;
  editExercise: boolean = false;
  type: string;
  subscriptions: Subscription[] = [];
  constructor(
    private planService: PlanService,
    private exerciseLogService: ExerciseLogService,
    private bottomsheetShared: BottomsheetShared,
    private diaryAnalytics: DiaryAnalyticsService
  ) {
    const bottomSheet = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.editExercise = false;
          this.LoadExercises();
        }
      }
    );
    this.subscriptions.push(bottomSheet);
    this.date = this.exerciseLogService.CDate;
    this.LoadExercises();
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  async ngOnInit() {
    this.diaryAnalytics.analyticDiaryActivityVisited();
  }
  back() {
    this.planService.goBack();
  }
  NewExercise() {
    this.planService.goToNewExercise();
  }
  openExercise(item: ResponseDayExerciseLogs) {
    if (item.exercise) {
      this.type = 'edit-exercise';
    } else {
      this.type = 'edit-custome-exercise';
    }

    this.bottomsheetShared.ExerciseLogDay = item;
    this.editExercise = true;
  }
  async LoadExercises() {
    const data = await this.exerciseLogService.getDayExercises(this.date);
    if (data) {
      this.exercises = data.exerciseLogs;
    }
  }
}
